import { expensesApi } from '../api/expensesApi'

export const deleteCategory = async (categoryId: string) => {
  try {
    const { data } = await expensesApi.deleteCategory(categoryId)
    return data
  } catch (error) {
    console.error(`Error deleting category: `, error)
    throw error
  }
}
